module.exports = __webpack_public_path__ + "img/suit-4.369298a4.jpg";